import React from "react"
import Waypoint from "react-waypoint"
import posed from "react-pose"

const PosedContainer = posed.div({
  enter: { y: 0, x: 0, opacity: 1 },
  left: { x: -200, opacity: 0 },
  right: { x: 200, opacity: 0 },
  bottom: { y: 200, opacity: 0 },
  top: { y: -200, opacity: 0 },
})

class Reveal extends React.PureComponent {
  state = { revealed: false }

  reveal = () => this.setState({ revealed: true })

  render() {
    const { renderPose, children, from, ...rest } = this.props
    const { revealed } = this.state

    return (
      <Waypoint onEnter={this.reveal}>
        {renderPose ? (
          renderPose(revealed)
        ) : (
          <PosedContainer
            pose={revealed ? "enter" : null}
            initialPose={from ? from : "bottom"}
            {...rest}
          >
            {children}
          </PosedContainer>
        )}
      </Waypoint>
    )
  }
}

export default Reveal



// WEBPACK FOOTER //
// ./src/components/Reveal/index.jsx